import styled from 'styled-components'
import { COLORS } from '../../common/constants'

export const TagmeLoggedInUserStyle = styled('div') <{
	colorMain: string | null,
	colorBorder: string | null
}>`
	border: 1px solid #CFCFCF;
	border-radius: 8px;
	padding: 12px;
	margin: 10px 15px;
	font-size: 12px;
	color: #464646;

	.media {
		display: flex;
		align-items: center;
	}

	.media-body {
		margin-left: 12px;


		strong {
			font-weight: 600;
			font-size: 16px;
		}

		p {
			margin: 0;
		}
	}

	button {
		height: 32px;
		padding: 2px;
		min-width: 78px;
		font-size: 12px;
		cursor: pointer;
		margin-left: auto;
		border-radius: 3px;
		text-align: center;
		text-decoration: none;
		display: inline-block;
		background-color: transparent;
		color: ${COLORS.fontColor};
		border: 2px solid ${props => props.colorBorder};
		
		&:active {
			background-color: ${props => props.colorBorder};
			color: white;
		}
	}

	img {
		width: 24px;
		height: 24px;
		border-radius: 50%;
		object-fit: cover;
		align-self: flex-start;
	}
`
